
function BigDown({ width = 24, height = 24, color = "#DEDEDE" }) {
	return (
		<svg height={height} width={width} viewBox="0 0 24 9" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M1 1L12 7L23 1" stroke={color} strokeWidth="2" strokeMiterlimit="10" />
		</svg>
	);
}

export default BigDown;
